import React, { useRef, useEffect } from "react";
import { Icon } from '../../ui-components';
import FeatureImages from './feature-images';
import {
  Wrap,
  CloseButton,
  ImageFrame,
  Title,
  Description,
} from './feature-info.styled';



export const FeatureInfo = ({ data, handleClose }) => {
  const popupRef = useRef()

  useEffect(() => {
    const checkIfClickedOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose()
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside)
    document.addEventListener("touchstart", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside)
      document.removeEventListener("touchstart", checkIfClickedOutside);
    }
  }, [handleClose])
  return (
    <Wrap ref={popupRef}>
      <CloseButton type="button" onClick={() => handleClose()}>
        <Icon
          name="close-outline"
          width={20}
          height={20}
          noFill
        />
      </CloseButton>
      {data.data.img
        ? (
          <ImageFrame>
            <FeatureImages
              name={data.data.img}
              alt={data.data.title}
            />
            <Title>{data.data.title}</Title>
          </ImageFrame>
        ) : null}
      <Description>{data.data.description}</Description>
    </Wrap>
  )
}
